import './MultiSelectDropdown.scss';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { Button, Col, Row, Select } from 'antd';
import React from 'react';
export const MultiSelectDropdown = ({ children, getPopupContainer = getDirectParent, selectedKeys, setSelectedKeys, confirm, options, visible }) => {
    if (!visible) {
        return null;
    }
    const dropdownRender = (menu) => React.createElement(React.Fragment, null,
        menu,
        children,
        React.createElement(Row, { className: 'filter-buttons', justify: 'space-between' },
            React.createElement(Col, null,
                React.createElement(Button, { disabled: !selectedKeys.length, onClick: () => {
                        setSelectedKeys([]);
                        confirm();
                    }, size: 'small', type: 'link' }, COPY_SPECIFIC.RESET)),
            React.createElement(Col, null,
                React.createElement(Button, { onClick: () => confirm(), size: 'small', type: 'primary' }, COPY_SPECIFIC.OK))));
    return (React.createElement(Select, { autoClearSearchValue: true, className: 'multi-select-dropdown', dropdownRender: dropdownRender, filterOption: caseInsensitiveContainsFilterOption, getPopupContainer: getPopupContainer, mode: 'multiple', onChange: setSelectedKeys, onDeselect: () => confirm(), onDropdownVisibleChange: () => !visible && confirm(), options: selectedKeys ? options : undefined, placeholder: COPY_SPECIFIC.SELECT_USER, showSearch: true, value: selectedKeys, variant: 'borderless' }));
};
